<template>
  <div class="white-rounded-box mb-7 h-fit tag-search-container w-full">
    <div class="search-box border-b-2">


<div class="mx-7 mt-6">
    <h2 class="text-xl">Tags</h2>
    <!-- removed for now - SA2-T614
<div class="mt-3">
<label
for="tag-search"
class="sr-only"
>Search Tag</label>
<div class="relative">
<input
id="tag-search"
name="tag-search"
class="block w-full py-2 pr-3 br-10 text-base placeholder-gray-400 focus:text-gray-900 focus:placeholder-gray-500 border-custom-grey"
placeholder="Search tag"
type="search"
v-model="search"
@change.prevent="onChange"
/>
<button
type="submit"
title="Search"
class="
  absolute
  inset-y-0
  right-0
  pl-3
  flex
  items-center
"
>
<svg-vue icon="search" title="Search" class="w-6 h-6 inline-block mr-3 fill-salesium-red" />
</button>
</div>
</div>-->
      </div>
    </div>
    <div class="tag-box h-fit mx-7 mt-5 flex flex-wrap">
      <!-- TODO: iterate through tags / add tags -->
      <Tag v-for="tag in tagsData" :key="tag.tag" :tag="tag" v-on:tagClicked="tagClicked" />
    </div>
  </div>
</template>

<script>
import Tag from './Tag.vue';
export default {
    props: ['tags'],
    // TODO: implement search functionality, presumably with items getting added to search tag box and type ahead
    data() {
        return {
            search: '',
        };
    },
    methods: {
        onChange(event) {
            console.log(event);
        },
        tagClicked(tag){
            this.$emit('tagClicked', tag);
        }
    },
    computed:{
      tagsData(){
        return this.tags.data.slice(0,10).map((tag) => ({'name': tag[1]}))
      }
    },
    components: {
        Tag,
    },
};
</script>

<style scoped>
.search-box {
    min-height: 140px;
}
.tag-box {
    min-height: 5rem;
}
</style>
